import React from "react";
import {connect} from "react-redux";
import {
    Breadcrumb,
    Table,
    ButtonToolbar,
    Button,
    SplitButton,
    MenuItem,
    Glyphicon,
    FormControl,
    Row,
    Col
} from "react-bootstrap";
import PaginationBar from "../../PaginationBar";
import Loading from "components/Loading";
import {LinkContainer} from "react-router-bootstrap";
import locale from "locale";
import CreatedModal from "./CreatedModal";
import CreateModal from "./CreateModal";
import FromFileModal from "./FromFileModal";
import "./style";
import {clientEmailAllowedDelete, clientEmailAllowedGet} from "api";

class EventAllowedEmails extends React.Component {
    state = {
        isLoading: true,
        entries: [],
        createdEntries: [],
        filterEmail: '',
        isShowCreate: false,
        activePage: 1,
    };

    constructor(props, context) {
        super(props, context);

        this.handleDelete = this.handleDelete.bind(this);

        this.onCreatedEntries = this.onCreatedEntries.bind(this);

        this.showCreate = this.showCreate.bind(this);
        this.hideCreate = this.hideCreate.bind(this);

        this.hideCreated = this.hideCreated.bind(this);
    }

    componentDidMount() {
        this.fetch();
    }

    fetch() {
        const {event} = this.props;

        this.setState({isLoading: true, entries: []});

        clientEmailAllowedGet(event.eventPassword)
            .then(entries => this.setState({entries, activePage: 1}))
            .catch(() => {})
            .then(() => this.setState({isLoading: false}))
        ;
    }

    handleDelete(entry) {
        const {event} = this.props;

        if (!confirm(`Вы действительно хотите удалить "${entry.email}"`)) {
            return;
        }

        clientEmailAllowedDelete(event.eventPassword, entry.email)
            .then(() => {
                let entries = this.state.entries.slice();
                let index = entries.findIndex(e => e.id === entry.id);
                if (index >= 0) {
                    entries.splice(index, 1);
                    this.setState({entries});
                }
            })
        ;
    }

    onCreatedEntries(createdEntries) {
        const emails = [];
        let entries = this.state.entries
            .concat(createdEntries)
            .filter((entry) => {
                if (-1 === emails.indexOf(entry.email)) {
                    emails.push(entry.email);

                    return true;
                }

                return false;
            })
        ;

        this.setState({
            isShowCreate: false,
            createdEntries,
            entries
        });
    }

    showCreate(type) {
        this.setState({isShowCreate: type, createdEntries: []});
    }

    hideCreate() {
        this.setState({isShowCreate: false});
    }

    hideCreated() {
        this.setState({createdEntries: []});
    }

    render() {
        const ticketOnPage = 100;
        const {isLoading, entries, filterEmail, activePage} = this.state;
        const {event} = this.props;

        if (isLoading) {
            return <Loading>Загрузка билетов</Loading>;
        }

        let entriesFiltered = entries;

        if (filterEmail) {
            entriesFiltered = entriesFiltered.filter(ticket => ~(ticket.email || '').indexOf(filterEmail));
        }

        const pageCount = Math.ceil(entriesFiltered.length / ticketOnPage);

        entriesFiltered = entriesFiltered.slice((activePage - 1) * ticketOnPage, activePage * ticketOnPage);

        const EntryRow = ({entry}) => {
            return (
                <tr>
                    <td>{entry.email}</td>
                    <td style={{textAlign: 'right'}}>
                        <Button bsSize="small" title="Удалить билет" onClick={() => this.handleDelete(entry)}><Glyphicon
                            glyph="remove"/></Button>
                    </td>
                </tr>
            );
        };

        return (
            <section className="Entries">
                <Breadcrumb>
                    <LinkContainer
                        to={`/event/${event.eventPassword}`}><Breadcrumb.Item>Трансляция</Breadcrumb.Item></LinkContainer>
                    <Breadcrumb.Item active>{locale('mainMenu.accessByEmails')}</Breadcrumb.Item>
                </Breadcrumb>
                <Row>
                    <Col xs={6}>
                        <ButtonToolbar>
                            {(event.moduleMain.ticketLimit - entries.length) > 0 && <span>
								<SplitButton title="Добавить" id="createTicketButtons"
                                             onClick={e => this.showCreate('number')}
                                             onSelect={type => this.showCreate(type)}>
									<MenuItem eventKey={'file'}>Из файла</MenuItem>
								</SplitButton>
							</span>}
                        </ButtonToolbar>
                    </Col>
                </Row>

                <Table responsive>
                    <thead>
                    <tr>
                        <th width="240">eMail</th>
                        <th width="120">{' '}</th>
                    </tr>
                    <tr>
                        <td>
                            <FormControl
                                type="text"
                                onChange={event => this.setState({filterEmail: event.target.value})}
                            />
                        </td>
                        <td/>
                    </tr>
                    </thead>
                    <tbody>
                    {entriesFiltered.map((entry) =>
                        <EntryRow
                            entry={entry}
                            key={entry.email}
                        />
                    )}
                    </tbody>
                </Table>

                <PaginationBar
                    pageCount={pageCount}
                    activePage={activePage}
                    onSelect={(activePage) => this.setState({activePage})}
                />

                <CreateModal
                    event={event} show={this.state.isShowCreate === 'number'}
                    max={event.moduleMain.ticketLimit - entries.length}
                    onCreate={this.onCreatedEntries}
                    onHide={this.hideCreate}
                />

                <FromFileModal
                    event={event} show={this.state.isShowCreate === 'file'}
                    max={event.moduleMain.ticketLimit - entries.length}
                    onCreate={this.onCreatedEntries}
                    onHide={this.hideCreate}
                />

                <CreatedModal entries={this.state.createdEntries} show={this.state.createdEntries.length > 0}
                              onHide={this.hideCreated}/>
            </section>
        );
    }
}

const mapStateToProps = (store) => {
    return {
        event: store.currentEvent
    };
};

export default connect(mapStateToProps)(EventAllowedEmails);
